import {
  domainsToClientId,
  domainsToLogo,
  domainsToStyle,
  domainsToCloudName,
} from '../enums/enums';
import { getSubdomain } from './getSubdomain';
import DefaultStyles from '@readcloud/clouds-and-content/src/components/styles/default.style.json';
import DefaultNames from '@readcloud/clouds-and-content/src/components/names/default.name.json';
import ReadCloud from '@readcloud/clouds-and-content/src/components/readcloud.svg';

const getSubdomainAssets = () => {
  const subdomain = getSubdomain();

  // Check if we're in a Tauri environment
  const isTauri = (window as any).__TAURI__ !== undefined;

  // Determine client ID based on environment
  let clientId: string;
  if (isTauri) {
    // Native app - use native client IDs
    if (subdomain === 'winc') {
      clientId = 'WINCNATIVE';
    } else {
      clientId = 'RCLNATIVE';
    }
  } else {
    // Web app - use existing subdomain mapping
    clientId =
      subdomain && subdomain in domainsToClientId
        ? domainsToClientId[subdomain]
        : 'RCL2021';
  }

  const logo =
    subdomain && subdomain in domainsToLogo
      ? domainsToLogo[subdomain]
      : ReadCloud;
  const style =
    subdomain && subdomain in domainsToStyle
      ? domainsToStyle[subdomain]
      : DefaultStyles;
  const name =
    subdomain && subdomain in domainsToCloudName
      ? domainsToCloudName[subdomain]
      : DefaultNames;

  return { logo, style, clientId, name };
};

export { getSubdomainAssets };
